/**
 * Feature Flags Configuration
 * 
 * Single source of truth for enabling/disabling features.
 * Flip a flag to `true` to enable a feature — no need to touch imports or routes.
 */
export const FEATURE_FLAGS = {
  // Customer-facing features
  flashSales: false,
  socialProof: false,
  liveChat: false,
  commandMenu: false,
  pwaPrompts: false,
  sharedWishlist: false,

  // Admin panel features
  adminAnalytics: false,
  adminReports: false,
  adminLoyalty: false,
  adminAbandonedCarts: false,
  adminReferrals: false,
  adminNewsletter: false,
  adminAuditLogs: false,
  adminFlashSales: false,
} as const;
